const getShortName = (item) => {
  if (!item || typeof item !== 'object') {
    return '';
  }
  // The issue may be due to a typo: the property should be 'linked_user_first_name' (snake_case) instead of 'linkedUserFirstName' (camelCase),
  // or the data source may use a different key. To cover all cases, check both:
  const firstName =
    item?.firstName || item?.first_name || item?.linkedUserFirstName || '';
  const lastName =
    item?.lastName || item?.last_name || item?.linkedUserLastName || '';

  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }
  return item.name?.[0]?.toUpperCase() || firstName?.[0]?.toUpperCase() || '-';
};

export default getShortName;
